import React from 'react';
import { MetricChip, PrimaryButton } from '../../shared';
import './SellerCardV2.css';

const SellerCardV2 = ({ seller, onSelect, isUserSeller, isSelf, isSubscribed }) => {
  const { name, bio, verified, backtest_win_rate, backtest_roi, win_rate, roi, total_picks } = seller;
  
  return (
    <div className={`seller-card-v2 ${isUserSeller ? 'user-seller' : ''} ${isSelf ? 'is-self' : ''} ${isSubscribed ? 'is-subscribed' : ''}`}>
      <div className="seller-header">
        <h3 className="seller-name">{name}</h3>
        {isSelf && <span className="self-badge">📋 Your Card</span>}
        {isSubscribed && !isSelf && <span className="subscribed-badge">✓ Subscribed</span>}
        {verified && <span className="verified-badge">✓ Verified</span>}
      </div>
      
      <p className="seller-bio">{bio}</p>
      
      {/* Live Performance */}
      <div className="performance-section live">
        <span className="section-label">Live Performance</span>
        <div className="metrics-row">
          <MetricChip label="Win Rate" value={`${win_rate || 0}%`} positive={win_rate >= 52} />
          <MetricChip label="ROI" value={`${roi > 0 ? '+' : ''}${roi || 0}%`} positive={roi > 0} />
          <MetricChip label="Picks" value={total_picks || 0} neutral />
        </div>
      </div>
      
      {/* Backtest - Only for AI cards */}
      {!isUserSeller && backtest_win_rate > 0 && (
        <div className="performance-section backtest">
          <span className="section-label">Backtest (Nov-Dec 2024)</span>
          <div className="metrics-row muted">
            <span className="backtest-stat">WR: {backtest_win_rate || 0}%</span>
            <span className="backtest-stat">ROI: {backtest_roi > 0 ? '+' : ''}{backtest_roi || 0}%</span>
          </div>
        </div>
      )}
      
      {!isUserSeller && <p className="strategy-update-note">Pick strategy updated Dec 22, 2025. Stats track updated strategy.</p>}
      
      <PrimaryButton onClick={() => onSelect(seller)} className="view-picks-btn">
        {isUserSeller && !isSelf && !isSubscribed ? '🔒 Subscribe to View' : 'View Available Picks'}
      </PrimaryButton>
    </div>
  );
};

export default SellerCardV2;
